import axios from "./index.service";

export default class CareerService {
  static createJob(payload) {
    return axios({
      method: "POST",
      url: "/api/services/v1/career/create-job",
      data: payload,
    });
  }

  static createScholarship(payload) {
    return axios({
      method: "POST",
      url: "/api/services/v1/career/create-scholarship",
      data: payload,
    });
  }

  static fetchAllJobs(pageAble) {
    return axios({
      method: "GET",
      url: "/api/services/v1/career/list-all-jobs",
      params: pageAble,
    });
  }

  static fetchAllScholarships(pageAble) {
    return axios({
      method: "GET",
      url: "/api/services/v1/career/list-all-scholarships",
      params: pageAble,
    });
  }

  static deleteAJob(jobId) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/career/delete-job/${jobId}`,
    });
  }

  static deleteScholarship(scholarshipId) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/career/delete-scholarship/${scholarshipId}`,
    });
  }
}
